import type { FC, ReactNode } from 'react'
import type { PixelPalette } from '@/lib/pixel'

import { cn } from '@/lib/utils'
import { PixelSprite } from '@/components/pixel/pixel-sprite'

import { MARQUEE_BOTTOM, MARQUEE_TOP } from '@/constants/content'
import { ICON_SPARKLE } from '@/constants/sprites'

interface MarqueeRowProps {
    items: ReadonlyArray<string>
    reverse?: boolean
    sparkle: PixelPalette
}

const INK_SPARKLE: PixelPalette = { K: 'var(--ink)' }

const PINK_SPARKLE: PixelPalette = { K: 'var(--bubblegum)' }

const MarqueeRow: FC<MarqueeRowProps> = ({ items, reverse = false, sparkle }): ReactNode => {
    return (
        <div className={cn('flex w-max hover:[animation-play-state:paused]', reverse ? 'animate-marquee-reverse' : 'animate-marquee')}>
            {[0, 1].map(copy => (
                <ul key={copy} aria-hidden={copy === 1 ? 'true' : undefined} className='flex shrink-0 items-center'>
                    {items.map(item => (
                        <li key={item} className='flex items-center'>
                            <span className='px-5 font-heading text-3xl leading-none whitespace-nowrap md:px-8 md:text-5xl'>
                                {item}
                            </span>
                            <PixelSprite rows={ICON_SPARKLE} palette={sparkle} className='size-5 shrink-0 md:size-7' />
                        </li>
                    ))}
                </ul>
            ))}
        </div>
    )
}

const MarqueeBand: FC = (): ReactNode => {
    return (
        <section id='what-we-do' aria-label="What we are good at" className='relative overflow-hidden py-14 md:py-20'>
            <div className='-mx-[6vw] -rotate-2 border-y-2 border-ink bg-bubblegum py-3 text-ink md:py-4'>
                <MarqueeRow items={MARQUEE_TOP} sparkle={INK_SPARKLE} />
            </div>

            <div className='-mx-[6vw] -mt-2 rotate-[1.5deg] border-y-2 border-ink bg-ink py-3 text-bubblegum md:-mt-3 md:py-4'>
                <MarqueeRow items={MARQUEE_BOTTOM} sparkle={PINK_SPARKLE} reverse />
            </div>
        </section>
    )
}

export default MarqueeBand
